import {ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import {useUniqueId} from "../../utils";
import "./Toggle.css";

export default function Toggle({label, half, wide, value, setValue, disabled, options} : {
    label?: string,
    half?: boolean,
    wide?: boolean,
    value?: number,
    setValue: (val: number) => void,
    disabled?: boolean,
    options: string[]
}) {
    const id = useUniqueId();
    return <>
        {label ? <div className={`${wide ? 'col-12 col-sm-10' : `col-4 ${half ? '' : 'col-lg-2'}`} vertical-center mb-2`}>
            {label}
        </div> : null}
        <ToggleButtonGroup className={`${wide ? 'col-12 col-sm-10' : `col-8 col-sm-6 ${half ? 'col-lg-6' : 'col-lg-3'}`} justify-content-center mb-2`}
                           type="radio" name={id} value={disabled ? -1 : value} onChange={setValue}>
            {options.map((o, idx) => {
                return <ToggleButton key={idx} value={idx} variant={'outline-info'} disabled={disabled} className={"toggleButton"}>
                    {o}
                </ToggleButton>
            })}
        </ToggleButtonGroup>
    </>
}

export function DependentToggle({label, dependentLabel, half, value, setValue, disabled, options, dependentOptions} : {
    label: string,
    dependentLabel: string,
    half?: boolean,
    value: number,
    setValue: (val: number) => void,
    disabled?: boolean,
    options: string[],
    dependentOptions: string[]
}) {
    const valTop = value === 0 ? 0 : Math.floor((value + 1) / 2)
    const valBottom = value === 0 ? 0 : (value + 1) % 2
    return <>
        <Toggle label={label} half={half} value={valTop} setValue={(v) => setValue(v === 0 ? 0 : (v * 2) - 1 + valBottom)} options={options} disabled={disabled}/>
        <Toggle label={dependentLabel} half={half} value={valBottom} setValue={(v) => setValue(v + (valTop * 2) - 1)} options={dependentOptions} disabled={value === 0 || disabled}/>
    </>
}
